import { PhoneInput } from '@makemydeal/dr-shared-components/phone-input';
import { Typography } from '@interstate/components/Typography';
import { featureToggleSelectors } from '@makemydeal/dr-shared-store';
import type { PhoneFieldKey } from '../../types';
import { useCustomerCardContext } from '../CustomerFormContext';
import { FieldsRow, SummaryFieldsRow } from './sectionLayout.styles';

const piiSlotProps = { textInput: { dataAttr: { className: 'pii' } } };

/**
 * Renders the Phone Numbers field group inside CustomerForm.
 * Reads all state and handlers from CustomerFormContext — accepts no props.
 *
 * Summary mode: phone/cell only (2-column grid, no section heading)
 * Full mode:    Phone Numbers heading + phone, homePhone, workPhone (3-column grid)
 */
const PhoneNumberFields = () => {
    const { formValues, handlePhoneInputChange, isLocked, viewMode, customerRole, enableCorrectPhoneHandling } =
        useCustomerCardContext();

    const Row = viewMode === 'full' ? FieldsRow : SummaryFieldsRow;
    const cellPhoneField: PhoneFieldKey = enableCorrectPhoneHandling ? 'cellPhone' : 'phone';
    const selectOnFocusSelector = featureToggleSelectors.isAutoSelectContentOnSlideOutsEnabledAfterBootstrap;

    return (
        <>
            {viewMode === 'full' && (
                <Typography variant="h5" sx={{ marginBottom: '1rem', marginTop: '1.5rem' }}>
                    Phone Numbers
                </Typography>
            )}
            <Row>
                <PhoneInput
                    label="Cell Phone"
                    name={cellPhoneField}
                    data-testid={`customer-form-${customerRole}-cell-phone`}
                    value={formValues[cellPhoneField] ?? ''}
                    onChange={(e) => handlePhoneInputChange(cellPhoneField, e)}
                    disabled={isLocked}
                    size="sm"
                    slotProps={piiSlotProps}
                    selectOnFocusSelector={selectOnFocusSelector}
                />
                {viewMode === 'full' && (
                    <PhoneInput
                        label="Home Phone"
                        name="homePhone"
                        data-testid={`customer-form-${customerRole}-home-phone`}
                        value={formValues.homePhone ?? ''}
                        onChange={(e) => handlePhoneInputChange('homePhone', e)}
                        disabled={isLocked}
                        size="sm"
                        slotProps={piiSlotProps}
                        selectOnFocusSelector={selectOnFocusSelector}
                    />
                )}
                {viewMode === 'full' && (
                    <PhoneInput
                        label="Work Phone"
                        name="workPhone"
                        data-testid={`customer-form-${customerRole}-work-phone`}
                        value={formValues.workPhone ?? ''}
                        onChange={(e) => handlePhoneInputChange('workPhone', e)}
                        disabled={isLocked}
                        size="sm"
                        slotProps={piiSlotProps}
                        selectOnFocusSelector={selectOnFocusSelector}
                    />
                )}
            </Row>
        </>
    );
};

PhoneNumberFields.displayName = 'PhoneNumberFields';
export default PhoneNumberFields;
